import { InlineRenameTitle } from '~/components/inline-rename-title';
import { useRenameChat } from '~/hooks/mutations/use-chat-mutations';

interface EditableChatTitleProps {
  sessionId: string;
  title: string | null;
  /** When set, the resting title is a button that opens the chat (Recycle bin
   *  card). When omitted the title is plain text (the Open card stretches a
   *  button across the whole card). */
  onOpen?: () => void;
  className?: string;
  /** See {@link InlineRenameTitle}'s props of the same names. */
  clickToEdit?: boolean;
  editInPopover?: boolean;
  textClassName?: string;
  triggerTestId?: string;
  inputTestId?: string;
}

/**
 * Inline chat rename (FRONT-545). A thin chat-specific wrapper over the shared
 * {@link InlineRenameTitle} so chats and files rename through the exact same
 * control. The rename mutation's invalidation propagates the new name to every
 * surface (pills, the Chats lists, search, the Files "From chat" badge).
 */
export function EditableChatTitle({
  sessionId,
  title,
  onOpen,
  className,
  clickToEdit,
  editInPopover,
  textClassName,
  triggerTestId,
  inputTestId,
}: EditableChatTitleProps) {
  const rename = useRenameChat();
  return (
    <InlineRenameTitle
      value={title}
      onOpen={onOpen}
      onSave={(next) => rename.mutateAsync({ sessionId, title: next })}
      fallback="New chat"
      successMessage="Chat renamed"
      failureMessage="Rename failed"
      className={className}
      clickToEdit={clickToEdit}
      editInPopover={editInPopover}
      textClassName={textClassName}
      triggerTestId={triggerTestId}
      inputTestId={inputTestId}
    />
  );
}
